<div class="page-container container w-100">
  <app-utility-toolbar />
  <h1 class="header mb-0">Automated Reports</h1>
  <div class="subtitle"
    >Manage your automated reports below or create a new automated report</div
  >
  <div class="row">
    @if (!loading) {
      <div class="col-12">
        <div class="buttons">
          <h5>Existing Automated Reports</h5>
          <button
            type="button"
            mat-raised-button
            class="my-2"
            color="primary"
            (click)="createNew($event)"
          >
            Create New
          </button>
        </div>
        <kendo-grid
          [kendoGridBinding]="gridData"
          [height]="600"
          [pageSize]="10"
          [pageable]="true"
          [sortable]="true"
        >
          @for (col of columns; track $index) {
            @if (col.field === 'cadenceValue') {
              <kendo-grid-column
                [field]="col.field"
                [title]="col.title"
                [width]="col.width"
              >
                <ng-template
                  let-group
                  let-field="field"
                  let-value="value"
                  kendoGridHeaderTemplate
                >
                  Cadence
                </ng-template>
                <ng-template let-dataItem kendoGridCellTemplate>
                  @if (dataItem.cadenceType === 'Daily') {
                    Daily
                  } @else if (dataItem.cadenceType === 'Weekly') {
                    Weekly on {{ getWeekdayLabel(+dataItem.cadenceValue) }}
                  } @else if (dataItem.cadenceType === 'Monthly') {
                    Monthly on the
                    {{ getMonthlySuffix(+dataItem.cadenceValue) }}
                  }
                </ng-template>
              </kendo-grid-column>
            } @else {
              <kendo-grid-column
                [field]="col.field"
                [title]="col.title"
                [width]="col.width"
              />
            }
          }
          <kendo-grid-column title="Actions" width="150">
            <ng-template let-dataItem kendoGridCellTemplate>
              <div class="auto-reports-actions">
                <button
                  type="button"
                  matIconButton
                  aria-label="Edit Record"
                  (click)="editRecord(dataItem)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  type="button"
                  matIconButton
                  aria-label="Delete Record"
                  (click)="deleteRecord(dataItem)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>
    }
    <ngx-loading [show]="loading" />
  </div>
</div>
